import {keepPreviousData, useQuery, useQueryClient} from '@tanstack/react-query';
import {queryClient} from '~/lib/queryClient';
import {IPaginator} from '~/lib/paginator';
import {fetchSourcesPage, ISourcesFilter, ISourcesPaginator} from '~/modules/Sources/api';
import {ISourceSummary} from '~/modules/Sources/models/Source';

const SOURCES_PAGE_KEY = ['sources-page'] as const;

export const SOURCES_PAGE_QUERY_KEY = (filter: ISourcesFilter, pagination: ISourcesPaginator) =>
    [...SOURCES_PAGE_KEY, filter, pagination] as const;

export const useSourcesPageQuery = (filter: ISourcesFilter, pagination: ISourcesPaginator) =>
    useQuery<IPaginator<ISourceSummary>>({
        queryKey: SOURCES_PAGE_QUERY_KEY(filter, pagination),
        queryFn: ({signal}) => fetchSourcesPage(filter, pagination, {signal}),
        placeholderData: keepPreviousData,
        staleTime: 30 * 1000
    });

export const prefetchSourcesPage = (filter: ISourcesFilter, pagination: ISourcesPaginator) =>
    queryClient.prefetchQuery({
        queryKey: SOURCES_PAGE_QUERY_KEY(filter, pagination),
        queryFn: ({signal}) => fetchSourcesPage(filter, pagination, {signal}),
        staleTime: 30 * 1000
    });

export const useSourcesAllQuery = () =>
    useQuery<ISourceSummary[]>({
        queryKey: ['sources-all'],
        queryFn: () => fetchSourcesPage({}, {}).then(r => r.items),
        staleTime: 5 * 60 * 1000,
    });

export const useInvalidateSourcesPageQuery = () => {
    const client = useQueryClient();
    return () => client.invalidateQueries({queryKey: SOURCES_PAGE_KEY});
};
